<template>
  <section>
    <div class="container no-bottom-mobile">
      <div class="is-col-12-md">
        <h1>LOG IN</h1>
        <p v-if="errors.length > 0" class="errorMsg-text" v-html="errors"></p>
        <p class="header-paragraph errorMsg-text" v-if="pwReset">
          <strong>Your password has been reset!</strong> You can now log in with your new password. </p>
        <p v-if="!pwReset">
          <span v-if="successRoute">Sorry! You need to log in to get to this page.</span> Don’t have an account yet? You
          can
          <router-link class="paragraph-link" :to="{ name: 'SignUp' }">sign up here.
          </router-link>
        </p>
      </div>
      <div class="is-col-12-md">
        <form id="loginForm" @submit.prevent="sendFormData">
          <div class="form-row-1">
            <div class="form-field">
              <label>Email address</label> <input class="input-field" v-model="loginEmail" type="text"/>
            </div>
            <div class="form-field name-field">
              <label>Password</label> <input class="input-field" v-model="loginPassword" type="password"/>
            </div>
          </div>
          <div>
            <p>
              <router-link class="paragraph-link" :to="{
                  name: 'ForgotPassword',
                  params: { initEmail: this.loginEmail },
                }">Forgot your password?
              </router-link>
            </p>
            <p>
              <router-link class="paragraph-link" :to="{ name: 'SignUp' }">
                Don't have an account? Create one.
              </router-link>
            </p>
          </div>
          <button>
            LOG IN <span><i class="fas fa-caret-right"></i></span>
          </button>
          <div class="loader-container" v-show="showLoader">
            <img src="@/assets/images/global/loader.gif" alt=""/>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>
<script>
import * as onetrust from '@/api/onetrust'

export default {
  created () {
    if (this.$store.state.isLoggedIn) {
      this.$router.push({ name: 'AccountDetail' }).catch(() => {})
    }
  },
  data () {
    return {
      loginEmail: this.$store.state.emailAddress,
      loginPassword: '',
      errors: '',
      errorMsg: '',
      pwReset: false,
      showLoader: false,
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET
    }
  },
  props: {
    successRoute: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.successRoute) {
      this.$store.commit('LOGOUT')
    }
    this.pwReset = this.$store.state.pwReset
    this.$store.state.pwReset = false
  },
  methods: {
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') {
        delete this.errors[field]
      }
    },
    async sendFormData () {
      this.$store.state.emailAddress = this.loginEmail
      this.showLoader = true

      try {
        const response = await this.axios.post(`${this.$apiUrl}v1/login`, {
          email: this.loginEmail,
          password: this.loginPassword
        })

        if (response.data.errors?.length === 0) {
          this.$store.state.loginEmail = this.loginEmail
          this.$store.state.firstName = response.data.first_name || 'Sun Hero'
          response.data.email = this.loginEmail
          this.$store.commit('SET_TOKEN', response.data)
          this.axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`

          // Fetch preferences and log them
          try {
            // Fetch preferences in any condition
            // If their preferences had previously opted out,
            // then remove cookies before proceeding.
            // Regardless of GPC enabled or not.
            const prefs = await onetrust.getPreferences(this.loginEmail)
            window.prefs = prefs // Save this for debugging in the console.
            console.log(prefs)
            if (['OPT_OUT', 'HARD_OPT_OUT', 'WITHDRAWN'].includes(prefs.status)) {
              await onetrust.removeCookies()
              console.info('Cookies removed due to previously saved as: ', prefs.status)
              await onetrust.disableCategories()
              console.info('A Updated OptanonConsent cookie to all zeroes')
              await onetrust.reInitOt()
            }
            //
            // Only skip if not enabled, cuz GPC means opt out.
            if (onetrust.isGpcEnabled()) {
              // If GPC is enabled, you have to save prefs
              // is not OPT_OUT, you gotta set it.
              await onetrust.savePreferences(this.loginEmail)
              console.info('Saved OT Preferences.')
              await onetrust.removeCookies()
              console.info('Removed all cookies except OptanonConsent')

              await onetrust.disableCategories()
              console.info('Updated OptanonConsent cookie')
              console.info('Did the second update consent jawn')
              // I think that's all I have to do... I hope?
            }
          } catch (error) {
            console.error('Error during login:', error)
          }

          /**
           *  Redirect to success route or default route
           * this.$router.push({ name: this.successRoute || 'HomeLoggedIn' }).catch(() => {})
           * NOTE: Yes, we know this is a stateful SPA, but OneTrust did not think of that
           * and their UI was not written to handle it. Therefore, we are forcing a reload of
           * the page so the OT UI will catch up to the change in the cookie.
           */
          window.location = '/homeloggedin'
        } else {
          this.errors = response.data.errors
          this.showLoader = false
        }
      } catch (error) {
        this.showLoader = false

        if (error.response?.status === 409) {
          this.errors = error.response.data.errors
        } else {
          this.errors = error
        }

        console.error('Error during login:', error)
      } finally {
        this.showResponse = true
        this.showLoader = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

h1 {
  font-size: 60px;
  text-align: left;
  margin-top: 65px;
  text-transform: uppercase;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    text-align: center;
    font-size: 45px;
    margin-top: 0px;
  }
}

.container {
  @media (min-width: 1025px) {
    // padding-left: 0;
  }
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-left: 2rem;
    top: 50px;
    min-height: 88vh;
  }
}

.input-field {
  width: 34.6rem;
  height: 4.5rem;
  margin-top: 1rem;
  margin-bottom: 3rem;
  box-shadow: inset 0 0 10px fade(black, 5%);
  border: 1px solid #b1b1b1;
  color: @color-txt-blue;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    width: 100%;
  }
}

form {
  margin-top: 40px;

  button {
    margin-top: 40px;
    background-color: @color-orange;
    font-weight: 700;
    font-family: @open-sans-font;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    cursor: pointer;

    span {
      margin-left: 10px;
    }

    @media screen and (max-width: 1000px) {
      // width: 226px;
      font-size: 15px;
    }

    .fa-caret-right {
      margin-left: 7px;
      @media screen and (max-width: 1000px) {
        margin-left: 3px;
      }
    }
  }
}

.loader-container {
  position: relative;
  top: -40px;
  left: 30%;
  @media screen and (min-width: ~"@{mq-md-bp}em") {
    left: 15%;
  }
}
</style>
